// #2c2c2a color is replaced by #000

///Get page url
var currentPageUrl = window.location.href;
var baseUrl = window.location.origin + "/";
var baseUrl2 = window.location.origin + "/#";
var baseUrl3 = window.location.origin + "/?_ab=0&_fd=0&_sc=1";

// menu variable for globle
    let navheader = document.querySelector('.navbar');
    let tlogo = document.querySelector('.transparent_logo');
    let slogo = document.querySelector('.standard_logo');
    let mtlogo = document.querySelector('.mtransparent_logo');
    let mslogo = document.querySelector('.mstandard_logo');
    let navbarnav = document.querySelector('.navbar-nav');
    let cartcount = document.querySelector('.cart-header-icon .cart-count');
    let mcartcount = document.querySelector('.cart-mobile .cart-count');
    let headerwicon = document.querySelector('#header-wishlist-icon');
    let headermwicon = document.querySelector('#mobile-wishlist-icon');
    let headeruicon = document.querySelector('#header-user-icon');
    let headeruicon2 = document.querySelector('#Ellipse71');
    let headercicon = document.querySelector('#header-cart-icon');
    let headercicon2 = document.querySelector('#header-cart-icon-2');
    let headermcicon = document.querySelector('#mobile-cart-icon');
    let headermcicon2 = document.querySelector('#mobile-cart-icon-2');
    let mobilemenu = document.querySelector('.mobile-sticky-header');
    let msearchicon = document.querySelector('.search-icon');
    let searchbar = this.document.querySelector('.searchdiv');
    let mmenu1 = document.querySelector('#mmenu1');
    let mmenu2 = document.querySelector('#mmenu2');
    let search1 = document.querySelector('#circle_search');
    let search2 = document.querySelector('#search_tail');

// Sticky Header
window.addEventListener('scroll', function() {   
    // navheader.classList.toggle('sticky-header', window.scrollY > 0);
    
    if (window.scrollY > 0){
        navheader.style.setProperty('top', '0px');
        mobilemenu.style.setProperty('top', '0px');
        msearchicon.style.setProperty('display', 'block');
        searchbar.style.setProperty('display', 'none');
        //if homepage
        if (currentPageUrl == baseUrl || currentPageUrl == baseUrl2 || currentPageUrl == baseUrl3){
            //mobile
            if (window.innerWidth <= 990) {

               // mtlogo.style.setProperty('display', 'none');
             //   mslogo.style.setProperty('display', 'block');
                mobilemenu.classList.remove('mobile-header');
                mobilemenu.classList.add('bgSnow');
                mmenu1.style.setProperty('stroke', '#000');
                mmenu2.style.setProperty('stroke', '#000');
                search1.style.setProperty('stroke', '#000');
                search2.style.setProperty('stroke', '#000');
                headerwicon.style.setProperty('stroke', '#000');
                headermwicon.style.setProperty('stroke', '#000');
                headermcicon.style.setProperty('stroke', '#000');
                headermcicon2.style.setProperty('stroke', '#000');
                searchbar.style.setProperty('display', 'none');
                mcartcount.style.setProperty('color', '#000');
                
            } else {
                //desktop
              
                navheader.classList.remove('gradient-header');
                navheader.classList.add('bgSnow');
                
                tlogo.style.setProperty('display', 'none');
                slogo.style.setProperty('display', 'block');
                navbarnav.classList.remove('white_txt');
                headerwicon.style.setProperty('stroke', '#000');
                cartcount.style.setProperty('color', '#000');
                headeruicon.style.setProperty('stroke', '#000');
                headeruicon2.style.setProperty('stroke', '#000');
                headercicon.style.setProperty('stroke', '#000');
                headercicon2.style.setProperty('stroke', '#000');
            }
        } else {
            if (window.innerWidth <= 990) {
                searchbar.style.setProperty('display', 'none');
            } else {
                
            }
        }
    } else {
        navheader.style.setProperty('top', '32px');
        mobilemenu.style.setProperty('top', '32px');
        msearchicon.style.setProperty('display', 'none');
        searchbar.style.setProperty('display', 'block');
        //if homepage
        if (currentPageUrl == baseUrl || currentPageUrl == baseUrl2 || currentPageUrl == baseUrl3){
            
            if (window.innerWidth <= 990) {
                //mobile
                mobilemenu.classList.add('mobile-header');
                mobilemenu.classList.remove('bgSnow');
               // mtlogo.style.setProperty('display', 'block');
               // mslogo.style.setProperty('display', 'none');
                mmenu1.style.setProperty('stroke', '#F4F3F0');
                mmenu2.style.setProperty('stroke', '#F4F3F0');
                search1.style.setProperty('stroke', '#F4F3F0');
                search2.style.setProperty('stroke', '#F4F3F0');
                headerwicon.style.setProperty('stroke', '#F4F3F0');
                headermwicon.style.setProperty('stroke', '#F4F3F0');
                headermcicon.style.setProperty('stroke', '#F4F3F0');
                headermcicon2.style.setProperty('stroke', '#F4F3F0');
                searchbar.style.setProperty('display', 'block');
                mcartcount.style.setProperty('color', '#F4F3F0');
            } else {

                //desktop
              var match = $(".dropdown-menu.mega-menu.show").attr('data-bs-popper');
              if(match != 'static'){
                navheader.classList.add('gradient-header');
                navheader.classList.remove('bgSnow');
                tlogo.style.setProperty('display', 'block');
                slogo.style.setProperty('display', 'none');
                navbarnav.classList.add('white_txt');
                headerwicon.style.setProperty('stroke', '#F4F3F0');
                cartcount.style.setProperty('color', '#F4F3F0');
                headeruicon.style.setProperty('stroke', '#F4F3F0');
                headeruicon2.style.setProperty('stroke', '#F4F3F0');
                headercicon.style.setProperty('stroke', '#F4F3F0');
                headercicon2.style.setProperty('stroke', '#F4F3F0');
                }
            }
        } else {
            if (window.innerWidth <= 990) {
                searchbar.style.setProperty('display', 'block');
            } else {
               
            }
        }
    }

  // menu hover header filled
    
});
// mouse hover stickey header
    let navLink = document.querySelectorAll('.dropdown-toggle');
    navLink.forEach(link => {
        link.addEventListener('mouseover', () => {
            navheader.classList.remove('gradient-header');
            navheader.classList.add('bgSnow');
            navbarnav.classList.remove('white_txt');
          if(window.innerWidth >= 992){
            tlogo.style.setProperty('display', 'none');
            slogo.style.setProperty('display', 'block');
            headerwicon.style.setProperty('stroke', '#000');
                cartcount.style.setProperty('color', '#000');
                headeruicon.style.setProperty('stroke', '#000');
                headeruicon2.style.setProperty('stroke', '#000');
                headercicon.style.setProperty('stroke', '#000');
                headercicon2.style.setProperty('stroke', '#000');
          }else{
            
          }
        });

        link.addEventListener('mouseout', () => {
            navheader.classList.add('gradient-header');
            navheader.classList.remove('bgSnow');
            navbarnav.classList.add('white_txt');
          if(window.innerWidth >= 992){
            tlogo.style.setProperty('display', 'block');
            slogo.style.setProperty('display', 'none');
            headerwicon.style.setProperty('stroke', 'rgb(244, 243, 240)');
            cartcount.style.setProperty('color', 'rgb(244, 243, 240)');
            headeruicon.style.setProperty('stroke', 'rgb(244, 243, 240)');
            headeruicon2.style.setProperty('stroke', 'rgb(244, 243, 240)');
            headercicon.style.setProperty('stroke', 'rgb(244, 243, 240)');
            headercicon2.style.setProperty('stroke', 'rgb(244, 243, 240)');
          }else{
            
          }
        });
    });
navheader.addEventListener('mouseover', ()=>{
  navheader.classList.add('bgSnow');
  navheader.classList.remove('gradient-header');
  navbarnav.classList.remove('white_txt');
  tlogo.style.setProperty('display', 'none');
  slogo.style.setProperty('display', 'block');
  headerwicon.style.setProperty('stroke', '#000');
  cartcount.style.setProperty('color', '#000');
  headeruicon.style.setProperty('stroke', '#000');
  headeruicon2.style.setProperty('stroke', '#000');
  headercicon.style.setProperty('stroke', '#000');
  headercicon2.style.setProperty('stroke', '#000');
});
navheader.addEventListener('mouseout', ()=>{
var match = $(".dropdown-menu.mega-menu.show").attr('data-bs-popper');
if(match != 'static'){
  navheader.classList.remove('bgSnow');
  navheader.classList.add('gradient-header');
  navbarnav.classList.add('white_txt');
  tlogo.style.setProperty('display', 'block');
  slogo.style.setProperty('display', 'none');
  headerwicon.style.setProperty('stroke', 'rgb(244, 243, 240)');
  cartcount.style.setProperty('color', 'rgb(244, 243, 240)');
  headeruicon.style.setProperty('stroke', 'rgb(244, 243, 240)');
  headeruicon2.style.setProperty('stroke', 'rgb(244, 243, 240)');
  headercicon.style.setProperty('stroke', 'rgb(244, 243, 240)');
  headercicon2.style.setProperty('stroke', 'rgb(244, 243, 240)');
}
});

// ---------------------------------------------------------------------------
// Money format handler
// ---------------------------------------------------------------------------
// SJ global front-end solution that automatically removes decimals

// SJ global front-end solution that automatically removes decimals

// SJ WITH DECIMAL VALUE
// var formatMoney = function(cents, format) {
//     if (typeof cents == 'string') { cents = cents.replace('.',''); }
//     var value = '';
//     var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
//     var formatString = (format || this.money_format);
  
//     function defaultOption(opt, def) {
//        return (typeof opt == 'undefined' ? def : opt);
//     }
  
//     function formatWithDelimiters(number, precision, thousands, decimal) {
//       precision = defaultOption(precision, 2);
//       thousands = defaultOption(thousands, ',');
//       decimal   = defaultOption(decimal, '.');
  
//       if (isNaN(number) || number == null) { return 0; }
  
//       number = (number/100.0).toFixed(precision);
  
//       var parts   = number.split('.'),
//           dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
//           cents   = parts[1] ? (decimal + parts[1]) : '';
  
//       return dollars + cents;
//     }
  
//     switch(formatString.match(placeholderRegex)[1]) {
//       case 'amount':
//         value = formatWithDelimiters(cents, 2);
//         break;
//       case 'amount_no_decimals':
//         value = formatWithDelimiters(cents, 0);
//         break;
//       case 'amount_with_comma_separator':
//         value = formatWithDelimiters(cents, 2, '.', ',');
//         break;
//       case 'amount_no_decimals_with_comma_separator':
//         value = formatWithDelimiters(cents, 0, '.', ',');
//         break;
//     }
  
//     return formatString.replace(placeholderRegex, value);
// };
// SJ WITH DECIMAL VALUE
// SJ REMOVE DECIMAL VALUE
var formatMoney = function(cents, format) {
  if (typeof cents == 'string') { cents = cents.replace('.', ''); }
  var value = '';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = (format || this.money_format);

  function defaultOption(opt, def) {
    return (typeof opt == 'undefined' ? def : opt);
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal   = defaultOption(decimal, '.');

    if (isNaN(number) || number == null) { return 0; }

    // Always use integer cents divided by 100
    number = (number / 100.0);

    // ✅ Force remove decimals completely
    number = Math.round(number);

    // Format with thousands separator
    var dollars = number.toString().replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);

    return dollars;
  }

  switch (formatString.match(placeholderRegex)[1]) {
    case 'amount':
    case 'amount_no_decimals':
    case 'amount_with_comma_separator':
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0);
      break;
  }

  return formatString.replace(placeholderRegex, value);
};
// SJ REMOVE DECIMAL VALUE
  
//Add to cart ajax
const addToCartForms = document.querySelectorAll('form[action="/cart/add"]');

addToCartForms.forEach((form) => {
form.addEventListener("submit", async (event) => {
    // Prevent normal submission
    event.preventDefault();

    // Submit form with ajax
    await fetch("/cart/add", {
    method: "post",
    body: new FormData(form),
    });

    // Get new cart object
    const res = await fetch("/cart.json");
    const cart = await res.json();

    // Update cart count
    document.querySelectorAll(".cart-count").forEach((el) => {
    el.textContent = cart.item_count;
    });

    // Display message
    //const message = document.createElement("p");
    //message.classList.add("added-to-cart");
    //message.textContent = "Added to cart!";
    //form.appendChild(message);
});
});
    

//CART DRAWER
function openCartDrawer() {
    document.querySelector(".cart-drawer").classList.add("cart-drawer--active");
  // SJ ADD_ON PRODUCT SCRIPT FUNCTIONS
    bindInsertAddToCart();
    bindNoThanksClick();
  // SJ ADD_ON PRODUCT SCRIPT FUNCTIONS
}

// SJ ADD_ON PRODUCT SCRIPT
function bindInsertAddToCart() {
  document.querySelectorAll(".add-insert-btn").forEach((button) => {
    button.addEventListener("click", async function (e) {
      e.preventDefault();
      e.stopPropagation();
      if (e.stopImmediatePropagation) e.stopImmediatePropagation();

      const $btn = this;
      const parent = $btn.closest(".insert-upsell-block");
      const insertId = parseInt(parent.getAttribute("data-insert-id"));
      const coverKey = parent.getAttribute("data-cover-key");

      $btn.disabled = true;
      $btn.textContent = "Adding...";

      try {
        // Fetch current cart
        const cart = await fetch("/cart.js").then(res => res.json());

        // Check if item already in cart with same properties
        const matchedItem = cart.items.find(item =>
          item.variant_id === insertId &&
          item.properties?._linked_to === coverKey
        );

        if (matchedItem) {
          // Re-add if previously removed or adjust quantity
          await fetch("/cart/change.js", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
              id: matchedItem.key,
              quantity: matchedItem.quantity + 1
            })
          });
        } else {
          // Add new item
          await fetch("/cart/add.js", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
              items: [{
                id: insertId,
                quantity: 1,
                properties: {
                  _linked_to: coverKey
                }
              }]
            })
          });
        }

        // Refresh cart drawer content
        const drawerHTML = await fetch('/?section_id=cart-drawer').then(res => res.text());
        const parser = new DOMParser();
        const doc = parser.parseFromString(drawerHTML, 'text/html');
        const newDrawer = doc.querySelector('.cart-drawer');
        const currentDrawer = document.querySelector('.cart-drawer');

        if (newDrawer && currentDrawer) {
          currentDrawer.innerHTML = newDrawer.innerHTML;
          currentDrawer.classList.add('cart-drawer--active');
          currentDrawer.scrollTop = 0;

          // ✅ Rebind dynamic elements
          if (typeof addCartDrawerListeners === 'function') addCartDrawerListeners();
          bindInsertAddToCart();
        }

      } catch (err) {
        console.error("Insert Add Error:", err);
        alert("Failed to add item. Please try again.");
      } finally {
        // ✅ Reset button state (important for retry)
        $btn.disabled = false;
        $btn.textContent = "Add to Cart +";
      }
      updateCartDrawer();
    });
  });
}

function bindNoThanksClick() {
  $('.no-thanks').off('click').on('click', function () {
    $(this).closest('.insert-upsell-block-main').hide();
  });
}

// // Remove add-ons when their parent is removed
// function removeOrphanInserts(currentKeys = []) {
//   fetch('/cart.js')
//     .then(res => res.json())
//     .then(cart => {
//       const toRemove = cart.items.filter(item => {
//         const linkedTo = item.properties?._linked_to;
//         return linkedTo && !currentKeys.includes(linkedTo);
//       });

//       const promises = toRemove.map(item => {
//         return fetch('/cart/change.js', {
//           method: 'POST',
//           headers: { 'Content-Type': 'application/json' },
//           body: JSON.stringify({ id: item.key, quantity: 0 })
//         });
//       });

//       if (promises.length > 0) {
//         Promise.all(promises).then(() => updateCartDrawer());
//       }
//     });
// }

// Remove add-ons when their parent is removed
function removeOrphanInserts() {
  fetch('/cart.js')
    .then(res => res.json())
    .then(cart => {
      const keys = cart.items.map(i => i.key);
      const deletions = cart.items
        .filter(i => i.properties?._linked_to && !keys.includes(i.properties._linked_to))
        .map(i =>
          fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: i.key, quantity: 0 })
          })
        );

      if (deletions.length) {
        var item = $("body .close_icon_cartdrawer.cart-item-removee").closest(".cart-drawer-item");
        var isAddOn = item.hasClass("is-addon");
        setTimeout(function(){
          if (isAddOn) {
            console.log("🔕 Skipping popup: this is an add-on item.1");
            $('.swym-wishlist-modal-container.swym-ui-component.swym-is-safari').css("display", "none");
          } else {
            console.log("🔕 Skipping popup: this is not an add-on item.1");
            $('.swym-wishlist-modal-container.swym-ui-component.swym-is-safari').css("display", "block");
          }
        },500);
        Promise.all(deletions).then(() => {
          updateCartDrawer();
        });
      }
    });
}
// Remove add-ons when their parent is removed
// SJ ADD_ON PRODUCT SCRIPT

function closeCartDrawer() {
    document
    .querySelector(".cart-drawer")
    .classList.remove("cart-drawer--active");
    setTimeout(async () => {
      const res = await fetch("/cart.js");
      const cart = await res.json();
      updateMobileCartItemCounts(cart.item_count);
    }, 300);
}

function updateMobileCartItemCounts(count) {
  document.querySelectorAll(".cart-count").forEach((el) => {
    el.textContent = count;
  });
  $(".mobile-icon-list span.cart-count").html(count);
}

function updateCartItemCounts(count) {
    document.querySelectorAll(".cart-count").forEach((el) => {
    el.textContent = count;
    });
  $("span.cart-count-dark").html(count);
}

async function updateCartDrawer() {
/*---console.log('hh');
    var varaint_price = $('.giftcartvaraintval').attr('varaint_price');
  if(varaint_price){   
    jQuery.getJSON('/cart.js', function(cart) {
  console.log(cart.total_price);
  if(cart.total_price > varaint_price){
  }else{
  removegiftcartproduct();
  }
  });
    }else{
  //  return true;
  }---*/


  
    const res = await fetch("/?section_id=cart-drawer");
    const text = await res.text();
    const html = document.createElement("div");
    html.innerHTML = text;

    const newBox = html.querySelector(".cart-drawer").innerHTML;

    document.querySelector(".cart-drawer").innerHTML = newBox;

    addCartDrawerListeners();
  
    //refreshcart_productsuggestion();
    // SJ ADD_ON PRODUCT SCRIPT FUNCTIONS
      bindInsertAddToCart();
      bindNoThanksClick();
    // SJ ADD_ON PRODUCT SCRIPT FUNCTIONS
  
    window.dispatchEvent(new CustomEvent('searchspring.recs.retarget', {}));

    <!-- SJ SWATCH WORK -->
    enforceSwatchLimits();
    <!-- SJ SWATCH WORK -->

}
<!-- SJ SWATCH WORK -->
function enforceSwatchLimits() {
  $('.cart-drawer-item-js[data-is-swatch="true"]').each(function() {
    $(this).find('.cart-drawer-quantity-selector-plus')
      .prop('disabled', true)
      .addClass('disabled')
      .css({ "pointer-events": "none", "opacity": "0.5" });

    // Keep minus button functional (removes at 0)
    $(this).find('.cart-drawer-quantity-selector-minus')
      .prop('disabled', false)
      .removeClass('disabled')
      .css({ "pointer-events": "auto", "opacity": "1" });

    // Force quantity back to 1 if user somehow hacks it
    const $input = $(this).find('input[name="quantity"], .cart-drawer-quantity-input');
    if ($input.length && parseInt($input.val()) > 1) {
      $input.val(1).trigger('change');
    }
  });
}

$(document).ready(function() {
  enforceSwatchLimits();

  // Watch for cart drawer changes
  const target = document.querySelector('.cart-drawer-main-box') || document.body;
  const observer = new MutationObserver(() => {
    enforceSwatchLimits();
  });
  observer.observe(target, { childList: true, subtree: true });
});
<!-- SJ SWATCH WORK -->


// // SJ--
// let previousCartKeys = [];
// async function updateCartDrawer() {
//   const res = await fetch("/?section_id=cart-drawer");
//   const text = await res.text();
//   const html = document.createElement("div");
//   html.innerHTML = text;

//   const newDrawer = html.querySelector(".cart-drawer");
//   const drawerContainer = document.querySelector(".cart-drawer");

//   if (newDrawer && drawerContainer) {
//     drawerContainer.innerHTML = newDrawer.innerHTML;
//     drawerContainer.classList.add('cart-drawer--active');
//     drawerContainer.scrollTop = 0;
//   }

//   // 🌀 Rebind dynamic add-on buttons
//   if (typeof addCartDrawerListeners === 'function') addCartDrawerListeners();
//   if (typeof bindInsertAddToCart === 'function') bindInsertAddToCart();
//   if (typeof bindNoThanksClick === 'function') bindNoThanksClick();

//   // Fetch latest cart and compare keys
//   const cart = await fetch('/cart.js').then(r => r.json());
//   const currentCartKeys = cart.items.map(i => i.key);

//   // Detect any removed main product (from last update)
//   const removedKeys = previousCartKeys.filter(key => !currentCartKeys.includes(key));
//   previousCartKeys = currentCartKeys;

//   // ✅ Only remove orphaned add-ons if something was removed
//   if (removedKeys.length > 0) {
//     removeOrphanInserts(currentCartKeys);
//   }

//   // Trigger any other custom events
//   window.dispatchEvent(new CustomEvent('searchspring.recs.retarget', {}));
// }
// // SJ--

function refreshcart_productsuggestion(){
var searchTerm = $('.load_product_cartdrawer').attr('product-title');
console.log(searchTerm);
if(searchTerm){
   $.ajax({
        url: `/search/suggest?q=${searchTerm}&resources[limit]=10&resources[type]=product,collection&section_id=predictive-cartdrawer-prduct`,
        type: 'GET',
        dataType: 'html',
        success: function(data) {
          $('.load_product_cartdrawer').html(data);
        },
        error: function(jqXHR, textStatus, errorThrown) {
          console.error("Error fetching line-item-list content:", errorThrown);
        }
      });
}else{
            $('.complete_thelook_slider').slick({
            centerMode: false,
            slidesToShow: 1,
            infinite: true,
            autoplay: false,
            autoplaySpeed: 1000,
            variableWidth: true,
            arrows: false,
            responsive: [
            {
            breakpoint: 768,
            settings: {
            arrows: false,
            centerMode: false,
            slidesToShow: 3
            }
            },
            {
            breakpoint: 480,
            settings: {
            arrows: false,
            centerMode: false,
            slidesToShow: 1,
            }
            }
            ]
            });
}
}



function deletecartitem(Key){
  $.ajax({
            type: 'POST',
            url: '/cart/change.js',
            dataType: 'json',
            data: {
                quantity: 0,
                id: Key
            },
           success: function (data) {
             updateCartDrawer();
             setTimeout(function(){
               // SJ ADD_ON PRODUCT SCRIPT FUNCTIONS
               // 🧼 Remove orphaned add-ons
               removeOrphanInserts();
               // SJ ADD_ON PRODUCT SCRIPT FUNCTIONS
             },1000);
           }
  });
        // Update cart
      
}

    document
    .querySelectorAll(".cart-drawer-quantity-selectorr button")
    .forEach((button) => {
        button.addEventListener("click", async () => {
          var $this = $(this);
        // Get line item key
        const rootItem =
            button.parentElement.parentElement.parentElement.parentElement
            .parentElement.parentElement;
      

        // Get new quantity
        const currentQuantity = Number(
            button.parentElement.querySelector("input").value
        );
          
        const isUp = button.classList.contains(
            "cart-drawer-quantity-selector-plus"
        );
        const newQuantity = isUp ? currentQuantity + 1 : currentQuantity - 1;
        // Ajax update\
        setTimeout(function(){
        updateprice();
        },500);
        });
    });

updateprice();
function updateprice(){
        let total = 0;
        let len =0;
        $('#a1_cultiver_qty').find('ul li').each(function() {
        var dataprice=$(this).find('.bundle_tbox#new_qty_base_price input').attr('dataprice');
        var qty =$(this).find('.bundle_tbox#new_qty_base_price .cart-drawer-quantity-selectorr input').val();
          len += parseInt(qty);
        if(dataprice){
        total += parseInt(dataprice * qty);
        }
        });
        if(total > 0){
        var totall =((total)/100);
        $('.product_card_box_js').find('span.product_price p.first_box_price span.money').html('$'+totall);
        }
    $('span#select_option_addtocart').html('ADD '+len+' ITEMS TO CART');
}


function addCartDrawerListeners() {
    // Update quantities
    document
    .querySelectorAll(".cart-drawer-quantity-selector button")
    .forEach((button) => {
        button.addEventListener("click", async () => {
          console.log('n1');
        // Get line item key
        const rootItem =
            button.parentElement.parentElement.parentElement.parentElement
            .parentElement.parentElement;
        const key = button.closest('.cart-drawer-item-js').getAttribute("data-line-item-key");

        // Get new quantity
        const currentQuantity = Number(
            button.parentElement.querySelector("input").value
        );
        const isUp = button.classList.contains(
            "cart-drawer-quantity-selector-plus"
        );
        const newQuantity = isUp ? currentQuantity + 1 : currentQuantity - 1;
        console.log(key +','+newQuantity);
        // Ajax update\
       /* const res = await fetch("/cart/update.js", {
            method: "post",
            headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            },
            body: JSON.stringify({ updates: { [key]: newQuantity } }),
        });
        const cart = await res.json();*/

          axios
          .post("/cart/change.js", {
          id: key,
          quantity : newQuantity,
          })
          .then((res) => {
                   jQuery.getJSON('/cart.js', function(cart) {
                  updateCartItemCounts(cart.item_count);
                  setTimeout(function(){  updatecart_Iconcounts(); },100);
                  // Update cart
                  updateCartDrawer();
                   });
          })
          .catch(error => {
            if (error.response) {
              console.log(error);
              // alert("in");
              // alert(error.response.data.message);
              $(`[data-line-item-key="${key}"] .set-error-cart.error-message`).html(error.response.data.message).show();

              if (error.response.data.message === "Only 1 item was added to your cart due to availability.") {
                $(`[data-line-item-key="${key}"] .cart-drawer-quantity-selector-plus`)
                  .attr("disabled", true)
                  .css({ cursor: "not-allowed", color: "var(--pearl-dark)" });
              }

            }
          });
      
        });
    });

    document.querySelector(".cart-drawer-box").addEventListener("click", (e) => {
    e.stopPropagation();
    });

    document
    .querySelectorAll(".cart-drawer-header-right-close, .cart-drawer")
    .forEach((el) => {
        el.addEventListener("click", () => {
        console.log("closing drawer");
$('.c_popup').css("display", "none");
        closeCartDrawer();
        });
    });

  // SJ--------
  $( "body .close_icon_cartdrawer.cart-item-removee" ).on( "click", function() {
    var Key = $(this).attr('cartitem');
    var item = $(this).closest(".cart-drawer-item");
    var isAddOn = item.hasClass("is-addon");
    setTimeout(function(){
      if (isAddOn) {
        console.log("🔕 Skipping popup: this is an add-on item.");
        $('.swym-wishlist-modal-container.swym-ui-component.swym-is-safari').css("display", "none");
      } else {
        console.log("🔕 Skipping popup: this is not an add-on item.");
        $('.swym-wishlist-modal-container.swym-ui-component.swym-is-safari').css("display", "block");
      }
    },500);
    console.log(Key);
    deletecartitem(Key);
    setTimeout(function(){  updatecart_Iconcounts(); },500);
  });
  // SJ----------

  function updatecart_Iconcounts(){
    jQuery.getJSON('/cart.js', function(cart) {
$("span.cart-count-dark").html(cart.item_count);
});
  }

  //cartdrawer toggle getit together
    $( "body .icon_cartdrawer" ).on( "click", function() {
$(this).parents(".complete_the_look.featured-products-slider").find('.load_product_cartdrawer').toggle("cart_drawerr_active_nocss");
 });


    $('.view-cart span a').click(function(e){
    e.preventDefault();
var cartpage=$(this).attr('href');
  window.location.href = cartpage;
  });

  $( "body #addtocart_popup_giftcart" ).on( "click", function() {
    freegiftcartcondition();
      });
    
      $('.remove-giftcart-product').on( "click", function() {
    $(this).parents(".giftcart_product_box").css('display','none');
      });
  
}

addCartDrawerListeners();

function errormessgaesize_show(){
    $("#sizeguide_error_message").show();
}  
function errormessgaesize_hide(){
    setTimeout(function () {
    $("#sizeguide_error_message").hide();
    }, 500); 
} 

document.querySelectorAll('form[action="/cart/add"]').forEach((form) => {
    form.addEventListener("submit", async (e) => {
    e.preventDefault();
 var inputcheck = $(form).find(".radio_nocss input:checked").val();

//console.log(inputcheck);
     console.log(form);
if(inputcheck){
  errormessgaesize_hide();

    // Submit form with ajax
    await fetch("/cart/add", {
        method: "post",
        body: new FormData(form),
    });

    // Get cart count
    const res = await fetch("/cart.js");
    const cart = await res.json();
    updateCartItemCounts(cart.item_count);

    // Update cart
    await updateCartDrawer();

    // Open cart drawer
    openCartDrawer();
  }
else{
   $(form).parents('.product_cultiver_parentjs_common').find("#sizeguide_error_message").show();
}
    });
});



document.querySelectorAll('a.cart-header-icon[href="/cart"], a[href="/cart"]').forEach((a) => {
    a.addEventListener("click", (e) => {
    e.preventDefault();
      console.log('nn1');
    //  checkgiftcartcondition();
    openCartDrawer();
    });
});

// zeynepjs
$(function() {

    var zeynep = $('.zeynep').zeynep({
        opened: function () {
            console.log('the side menu is opened')
        }
    })

    // dynamically bind 'closing' event
    zeynep.on('closing', function () {
        console.log('this event is dynamically binded')
    })

    // handle zeynepjs overlay click
    $('.zeynep-overlay').on('click', function () {
        zeynep.close()
    })

    // open zeynepjs side menu
    $('.btn-open').on('click', function () {
        zeynep.open()
    })
})

$("#announcementModal").on("click", function() {
    // Show the modal
    $("#announcementModalBar").modal("show");
});

$("#switchCountry").on("click", function() {
    // Show the modal
    $("#switchCountryModal").modal("show");
});



$(document).ready(function(){
    WindowWidth = $(window).width();
    
    if ($('.template_style_2')[0]) {
        if (WindowWidth <= 990) {
        
            $(".middle-left").css("position", "relative");
            $(".middle-center").css("position", "relative");
            $(".top-left").css("position", "relative");
            $(".topmost-right").css("position", "relative");
            $(".bottom-right").css("position", "relative");
            $(".bottom-left").css("position", "relative");
            $(".middle-right").css("position", "relative");
        } else {

        }
    } 

})

$('.product_item').hover(function (e) { // mouse-in 
    $(this).find('.product-card_buttons').css("opacity", "1");
    $(this).find('.product_hover').css("opacity", "1");
 //  $(this).find('.c_popup').css("display", "block");
},
    function () { // mouse-out
        $(this).find('.product-card_buttons').css("opacity", "0");
        $(this).find('.variant-options_js').css("display", "none");
        $(this).find('.product_hover').css("opacity", "0");
     //  $(this).find('.c_popup').css("display", "none");
    }
)

//Changing svg stroke color on hover
$(".blog-btn").mouseover(function(){
    $(this).find('.svg_default').css('transform', 'translate(3px, 0px)');
    $(this).find('.svg_default').css('transition', '.4s ease');
    $(this).find('.svg_default path').css('stroke', '#8A6D4B'); 
    
});
$(".blog-btn").mouseout(function(){
    $(this).find('.svg_default').css('transform', 'translate(0px, 0px)');
    $(this).find('.svg_default').css('transition', '.4s ease');
    $(this).find('.svg_default path').css('stroke', '#000'); 
});

$(".button-tertiary-with-icon").mouseover(function(){
    $(this).find('.svg_default').css('transform', 'translate(3px, 0px)');
    $(this).find('.svg_default').css('transition', '.4s ease');
    $(this).find('.svg_default path').css('stroke', '#8A6D4B'); 
    $('.featured-products-slider .variantbox').css('color', '#8A6D4B');
    
});
$(".button-tertiary-with-icon").mouseout(function(){
    $(this).find('.svg_default').css('transform', 'translate(0px, 0px)');
    $(this).find('.svg_default').css('transition', '.4s ease');
    $(this).find('.svg_default path').css('stroke', '#000'); 
    $(this).find('.featured-products-slider .variantbox').css('color', '#979C8F');
});

$(".search_form").mouseover(function(){
    $(this).find('.btn-search').css('transform', 'translate(-3px, 0px)');
    $(this).find('.svg_search path').css('stroke', '#8A6D4B'); 
    
});

$(".search_form").mouseout(function(){
    $(this).find('.btn-search').css('transform', 'translate(0px, 0px)');
    $(this).find('.svg_search path').css('stroke', '#000'); 
});


$(".search, .search_form.cultiver_search_disable").mouseover(function(){
    var isDisabled = $(this).find('input[type="search"]').prop('disabled');
 console.log(isDisabled);
 if(isDisabled === true){}else{
     $(this).find('.search-btn').css('transform', 'translate(-3px, 0px)');
     $(this).find('.svg_search path').css('stroke', '#8A6D4B'); 
 }
 });

$(".search").mouseout(function(){
    $(this).find('.search-btn').css('transform', 'translate(0px, 0px)');
    $(this).find('.svg_search path').css('stroke', '#000'); 
});


//Prevent scrolling when link is clicked
$('a#announcementModal').click(function(e) {
    e.preventDefault();
});

$('a#switchCountry').click(function(e) {
    e.preventDefault();
});


//Close mobile menu

$('.mclose-button').click(function() {
    // console.log('Test');
    $('.zeynep').removeClass('opened')
    $('html').removeClass('zeynep-opened')
});


// Close box
const box = document.querySelector('.box');
const closeButton = document.querySelector('.box-close');


document.querySelectorAll('.box').forEach(closeButton => {
    closeButton.addEventListener('click', function() {
        box.style.display = 'none';
    });
});






// Dropdown

//Multiple options dropdown

//https://codepen.io/gatoledo1/pen/QWmpWjK
function updategiftcartproduct(){
    var variant_id = $('.giftcartvaraintval').attr('varaint_id');
    if(variant_id){
     $.ajax({
              type: 'POST',
              url: '/cart/change.js',
              dataType: 'json',
              data: {
                  quantity: 1,
                  id: variant_id
              },
             success: function (data) {
                  updateCartDrawer();
             }
            });
      }else{
    return true;
  }
  }

function removegiftcartproduct(){
    var variant_id = $('.giftcartvaraintval').attr('varaint_id');
    if(variant_id){
     $.ajax({
              type: 'POST',
              url: '/cart/change.js',
              dataType: 'json',
              data: {
                  quantity: 0,
                  id: variant_id
              },
             success: function (data) {
                  updateCartDrawer();
             }
            });
      }else{
    return true;
  }
  }
  
  function addgiftcartproduct(){
  var variant_id = $('.giftcartvaraintval.active').attr('varaint_id');
  if(variant_id){
     $.ajax({
              type: 'POST',
              url: '/cart/add.js',
              dataType: 'json',
              data: {
                  quantity: 1,
                  id: variant_id
              },
             success: function (data) {
                  updateCartDrawer();
             }
            });
  }else{
    return true;
  }
  }
  
  
  function freegiftcartcondition(){
    console.log('n1');
    var varaint_price = $('.giftcartvaraintval').attr('varaint_price');
  if(varaint_price){   
    jQuery.getJSON('/cart.js', function(cart) {
  console.log(cart.total_price);
  if(cart.total_price > varaint_price){
  addgiftcartproduct();
  }else{
 // removegiftcartproduct();
  }
  });
    }else{
    return true;
  }
  }

 // checkgiftcartcondition();

function checkgiftcartcondition(){
  console.log('n1');
  var varaint_price = $('.giftcartvaraintval').attr('varaint_price');
if(varaint_price){   
  jQuery.getJSON('/cart.js', function(cart) {
console.log(cart.total_price);
if(cart.total_price > varaint_price){
updategiftcartproduct();
  cart_count();
}else{
//removegiftcartproduct();
  cart_count();
}
});
  }else{
  return true;
}
}

function cart_count(){
    setTimeout(function() {
    jQuery.getJSON('/cart.js', function(cart) {
    $("span.cart-count-dark").html(cart.item_count);
    });
    },500);
}




